// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-core-card-with-label-coreCardWithLabel-module__container-RvwlhS","textContainer":"src-domain-components-core-card-with-label-coreCardWithLabel-module__textContainer-QZ1d1x","label":"src-domain-components-core-card-with-label-coreCardWithLabel-module__label-Wt0RmD"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-core-card-with-label-coreCardWithLabel-module__container-RvwlhS\",\"textContainer\":\"src-domain-components-core-card-with-label-coreCardWithLabel-module__textContainer-QZ1d1x\",\"label\":\"src-domain-components-core-card-with-label-coreCardWithLabel-module__label-Wt0RmD\"}";
        // 1793705033185
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  